import * as _ from 'lodash';
import { Action } from '../actions/commonActions';
import { Notification, NotificationType } from '../models/notification';
import { getDefaultNotificationState, NotificationState } from '../models/state/notificationState';

import {
  ADD_NOTIFICATION,
  CLOSE_NOTIFICATION_PANEL,
  DISMISS_ALL_NOTIFICATIONS,
  DISMISS_NOTIFICATION,
  HIDE_ALL_NOTIFICATION_POPUPS,
  HIDE_NOTIFICATION_POPUP,
  OPEN_NOTIFICATION_PANEL,
} from '../actions/actionTypes';

export default function notificationReducer(
  state: NotificationState = getDefaultNotificationState(),
  action: Action<any>,
): NotificationState {
  switch (action.type) {
    case ADD_NOTIFICATION: {
      let notification = action.payload as Notification;
      if (state.isPanelOpen) {
        /*
                        if the notification panel is open immediately mark the
                        notification as hidden (no popup) and read (no count).
                    */
        notification = Object.assign({}, notification, {
          hidden: true,
          read: true,
        });
      }

      return Object.assign({}, state, {
        notifications: [...state.notifications, notification],
      });
    }
    case HIDE_NOTIFICATION_POPUP: {
      const typedAction = action as Action<number>;
      if (typedAction.payload) {
        const uid = typedAction.payload;
        const notification = _.find(state.notifications, (n) => n.uid === uid);
        if (notification) {
          const newNotification = Object.assign({}, notification, {
            hidden: true,
          });

          return Object.assign({}, state, {
            notifications: [...state.notifications.filter((n) => n.uid !== uid), newNotification],
          });
        }
      }
    }
    case CLOSE_NOTIFICATION_PANEL: {
      return Object.assign({}, state, {
        isPanelOpen: false,
      });
    }
    case OPEN_NOTIFICATION_PANEL: {
      const currentUnreadNotifications = state.notifications.filter((n) => !n.read);
      const newNotifications = currentUnreadNotifications.map((n) =>
        Object.assign({}, n, {
          read: true,
        }),
      );

      let notifications = state.notifications;
      if (newNotifications.length > 0) {
        notifications = [..._.differenceWith(state.notifications, currentUnreadNotifications), ...newNotifications];
      }

      return Object.assign({}, state, {
        isPanelOpen: true,
        notifications,
      });
    }
    case HIDE_ALL_NOTIFICATION_POPUPS: {
      // get the notifications currently "popped up"
      const currentPopupNotifications = state.notifications.filter((n) => !n.hidden);

      // create instances with the hidden flag set to true
      const notificationsToHide = currentPopupNotifications.map((n) =>
        Object.assign({}, n, {
          hidden: true,
        }),
      );

      const notifications = [
        ..._.differenceWith(state.notifications, currentPopupNotifications),
        ...notificationsToHide,
      ];

      return Object.assign({}, state, {
        notifications,
      });
    }
    case DISMISS_ALL_NOTIFICATIONS: {
      const typedAction = action as Action<NotificationType>;

      const notificationsToDismiss = state.notifications.filter(
        (n) => !typedAction.payload || n.type === typedAction.payload,
      );

      const notifications = [..._.differenceWith(state.notifications, notificationsToDismiss)];

      return Object.assign({}, state, {
        notifications,
      });
    }
    case DISMISS_NOTIFICATION: {
      const id = action.payload as number;
      return Object.assign({}, state, {
        notifications: state.notifications.filter((n) => n.uid !== id),
      });
    }
  }

  return state;
}
